import { callApi } from './ApiClient';

const postFollowCallOrdersOrder = (data, dispatch) => {
  return callApi('POST', '/follow-call-orders/order', data, dispatch);
}

const getFollowCallOrders = (data, dispatch) => {
  return callApi('GET', '/follow-call-orders', data, dispatch);
}

const postFollowCallOrdersSalesforceSync = (data, dispatch) => {
  return callApi('POST', `/follow-call-orders/salesforce/sync`, data, dispatch);
}

export const FollowCallOrdersApi = {
  postFollowCallOrdersOrder,
  getFollowCallOrders,
  postFollowCallOrdersSalesforceSync,
};



// WEBPACK FOOTER //
// ./src/redux/api/FollowCallOrdersApi.js